import { render, staticRenderFns } from "./variables.vue?vue&type=template&id=5d5708c6&scoped=true"
import script from "./variables.vue?vue&type=script&lang=js"
export * from "./variables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5708c6",
  null
  
)

export default component.exports